import request from '@/utils/request'

/**
 * 获取售后知识库分类
 */
export function getAfterknowType() {
  return request({
    url: 'api/getAfterknowType',
    method: 'post'
  })
}

/**
 * 添加/修改售后知识库分类
 */
export function editAfterknowType(data) {
  return request({
    url: 'api/editAfterknowType',
    method: 'post',
    params: data
  })
}

/**
 * 删除售后知识库分类
 */
export function delAfterknowType(data) {
  return request({
    url: 'api/delAfterknowType',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后知识库列表
 */
export function getAfterknowList(data) {
  return request({
    url: 'api/getAfterknowList',
    method: 'post',
    params: data
  })
}

/**
 * 删除售后知识库
 */
export function delAfterknow(data) {
  return request({
    url: 'api/delAfterknow',
    method: 'post',
    params: data
  })
}

/**
 * 添加/编辑售后知识库
 */
export function editAfterknow(data) {
  return request({
    url: 'api/editAfterknow',
    method: 'post',
    params: data
  })
}

/**
 * 获取售后知识库详情
 */
export function getAfterknowDetail(data) {
  return request({
    url: 'api/getAfterknowDetail',
    method: 'post',
    params: data
  })
}
